
export const parseStringArray = (str) => {
  try {
    if (str.startsWith("['")) {
      // Replace outer single quotes with double quotes
      str = str.replace(/'/g, '"');
    }
    return JSON.parse(str);
  } catch (e) {
    console.error("Invalid JSON string:", e);
    return [];
  }
}